// extracted by mini-css-extract-plugin
module.exports = {"standoutFeaturesSection":"StandoutFeature_standoutFeaturesSection__JKmjk","heading":"StandoutFeature_heading__QQRCD","carousalContainer":"StandoutFeature_carousalContainer__WivXz"};